import Vuex from "vuex";
import VenueService from "../api/venue.js";
import UserService from "../api/user.js";
import OrderService from "../api/orders.js"
import createPersistedState from 'vuex-persistedstate';
import Vue from 'vue'

Vue.use(Vuex)


const store = new Vuex.Store({
    namespaced: true,
    plugins:[createPersistedState()],
    modules: {
    //    protocol: protocol
    },
    state: { 
       venues:[],
       loadedVenues:false,
        loggedInUser:'',
        isBusinessAccount:'',
        metrics: null,
        lastMetricsUpdate: null,
    },
        
    mutations: {
        setMetrics(state, payload) {
            state.metrics = payload.metrics;
            state.lastMetricsUpdate = payload.lastUpdated;
        },
        setInitial(state){        
            state.venues = [],
            state.loadedVenues = false,
            state.loggedInUser = ''
            state.isBusinessAccount = ''
            state.metrics = null
            state.lastMetricsUpdate = null
            localStorage.clear();
            sessionStorage.clear();
        },
        updateVenue(state, data) {
            state.venues.splice(data.index, 1, data.venue);
        },
        saveVenue(state, data) {
            state.venues.push(data);
        },
        venueLookupValues(state, venues){
            state.venues = venues;
            state.loadedVenues = true;
            //state.bars = bars

        },
        lookupValues(state, lookupEvents) {
            state.VRCCSMLookUpValues = lookupEvents;
        },
       async loadUser(state,payload){
        if(payload.status==="success"){
            console.log(payload.data.user)
            if(payload.data.user.isBusinessAccount){
                sessionStorage.setItem('businessID',payload.data.user._id);
                
                sessionStorage.setItem('user',payload.data.user._id);
                sessionStorage.setItem('EmployeeCode',payload.data.user.randomCode);
                sessionStorage.setItem('isBusiness',true);
                
            }
            else{
                sessionStorage.setItem('businessID',payload.data.user.businessID);
                sessionStorage.setItem('user',payload.data.user._id);
                sessionStorage.setItem('isBusiness',false);
            }
           //payload.data.user.isBusinessAccount);
           sessionStorage.setItem('chargesEnabled',payload.data.user.chargesEnabled || false);
           sessionStorage.setItem('stripeAccountCreated',payload.data.user.stripeAccountCreated);                
            sessionStorage.setItem('token',payload.token);
            
            
            state.loggedInUser= payload.data.user.name
            state.isBusinessAccount = payload.data.user.isBusinessAccount
        }
        
       }

    },
    actions: {
        async fetchMetrics({ commit }) {
            const now = Date.now();
            const lastFetch = localStorage.getItem('lastStatsFetch');
            const twoHours = 2 * 60 * 60 * 1000;

            if (!lastFetch || now - parseInt(lastFetch) > twoHours) {
            const data = await OrderService.getHomePageMetrics();

            if (data) {
                commit('setMetrics', {
                metrics: data,
                lastUpdated: now,
                });

                localStorage.setItem('lastStatsFetch', now.toString());
                localStorage.setItem('metrics', JSON.stringify(data));
            }
            } else {
            // fallback to localStorage
            const cached = localStorage.getItem('metrics');
            if (cached) {
                commit('setMetrics', {
                metrics: JSON.parse(cached),
                lastUpdated: parseInt(lastFetch),
                });
            }
            }
        },
        async updateVenue(context,data){
           context.commit("updateVenue", data )
        },
        async saveVenue(context,data){
            context.commit("saveVenue", data )
         },
        async login(context,credentials){
            context.commit("loadUser", await UserService.login(credentials))
        },
        async signup(context,credentials){
            context.commit("loadUser", await UserService.signUp(credentials))
        },
        async venueLookup(context){
            context.commit("venueLookupValues", await VenueService.getAllVenuesForUser(sessionStorage.getItem('businessID')))
        },
        async setInitial({ commit }) {
            commit('setInitial');
          },
    }
});


export default store;